/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuList, NeuIcon } from '@neutron/react';

export const StyledDiv = styled.div`
  position: relative;
  width: 100%;
  left: 0px;
  margin-top: 50px;
  background: #f6f6f6;
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
`;

export const ContentContainer = styled.div`
  display: flex;
  height: calc(100vh - 163px);
`;
export const WrapperContainer = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 163px);
  padding: 0 1rem 2rem;
  overflow-y: scroll;
`;
export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 0%;
  width: 100%;
`;
export const FacilityInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
`;
export const UnitListContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;
export const UnitListContainerLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 0%;
  width: 40%;
  margin-top: 16px;
  padding: 0.5em 1em;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
`;
export const UnitListContainerRight = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 0%;
  width: 40%;
  margin-top: 16px;
  padding: 0.5em 1em;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
  margin-left: 30px;
`;

export const InputHeading = styled.div`
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 22px;
  width: 90%;
  margin-top: 12px;
  margin-bottom: 0.4rem;
`;
export const UnitList = styled(NeuList)`
  height: calc(100% - 38px);
  overflow-y: scroll;
  scroll-behavior: smooth;
  margin-bottom: 33px;
  cursor: auto;
`;
export const UnitItemHeading = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 22px;
  color: #4b4b4b;
  > div {
    min-height: 55px;
    margin: 0;
  }
`;
export const UnitItem = styled(NeuList)`
  cursor: auto;
`;
export const UnitLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: auto;
`;
export const IconFavoriteUnit = styled(NeuIcon)`
  width: 24px;
  height: 24px;
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  color: #b68d41;
  float: right;
  cursor: pointer;
  &:hover {
    --icon-fill: 100;
  }
`;
export const IconFavoriteUnitWithHover = styled(IconFavoriteUnit)`
  &:hover {
    --icon-fill: 100;
  }
`;
export const IconFavoriteUnitSavedWithHover = styled(IconFavoriteUnit)`
  &:hover {
    --icon-fill: 0;
  }
`;
export const SpinnerContainer = styled.span`
  margin-left: 10px;
`;
